<template>
  <img src="../../assets/none/theDefaultPage.png" class="noneImg">
</template>

<script>
  export default {
    name: 'none'
  }
</script>

<style scoped lang="scss">
  .noneImg {
    width: 100%;
    height: auto;
    max-width: 7.5rem;
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/none/index.vue